// AUTH States
const LOADING = "LOADING";
const LOGGEDIN = "LOGGEDIN";
const LOGGEDOUT = "LOGGEDOUT";

export { LOADING, LOGGEDIN, LOGGEDOUT };
